export enum AlertSeverity {
    ERROR = "error",
    WARNING = "warning",
    SUCCESS = "success",
    INFO = "info",
}
